var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentHoodSampleAgents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2998_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1709 3.7905V13.4305L14.0261 14.7232L20.1245 13.4305V3.7905C20.1245 3.13847 19.5919 2.60547 18.9404 2.60547C15.6736 2.60547 12.5424 2.60547 9.35526 2.60547C8.70345 2.60547 8.1709 3.13847 8.1709 3.7905Z",
    fill: "#FFCC73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1709 3.7905V13.4305H9.89114V3.7905C9.89114 3.13847 10.4237 2.60547 11.0753 2.60547H9.35526C8.70345 2.60547 8.1709 3.13847 8.1709 3.7905Z",
    fill: "#F59556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3571 5.22576H15.7925C16.1003 5.22576 16.3534 4.97243 16.3534 4.6629V2.60547H11.7947V4.6629C11.7947 4.97243 12.0478 5.22576 12.3571 5.22576Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57202 14.6157V24.2557L8.42725 25.5485L14.5256 24.2557L15.5759 19.1029L14.5256 14.6157C14.3767 13.9801 13.9929 13.4305 13.3413 13.4305C10.0747 13.4305 6.94353 13.4305 3.75616 13.4305C3.10458 13.4305 2.57202 13.9635 2.57202 14.6157Z",
    fill: "#F59556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57202 14.6157V24.2557C3.04661 24.2424 3.62563 24.249 4.29204 24.2406V14.6157C4.29204 13.9635 4.82481 13.4305 5.4764 13.4305H3.75616C3.10458 13.4305 2.57202 13.9635 2.57202 14.6157Z",
    fill: "#D65036"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75841 16.0508H10.1938C10.5031 16.0508 10.7544 15.7974 10.7544 15.4879V13.4305H6.19775V15.4879C6.19775 15.7974 6.4491 16.0508 6.75841 16.0508Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5256 14.6157V24.2557C15.7795 24.2209 18.0073 25.5533 20.3809 25.5485C22.3111 25.5449 24.2612 24.2192 26.4792 24.2258V14.6157C26.4792 13.9635 25.9467 13.4305 25.2951 13.4305C22.0283 13.4305 18.8971 13.4305 15.7098 13.4305C15.0582 13.4305 14.5256 13.9635 14.5256 14.6157Z",
    fill: "#55B8E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5256 14.6157V24.2557L16.2459 24.2406V14.6157C16.2459 13.9635 16.7784 13.4305 17.43 13.4305H15.7098C15.0582 13.4305 14.5256 13.9635 14.5256 14.6157Z",
    fill: "#507FCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7121 16.0508H22.1459C22.455 16.0508 22.7081 15.7974 22.7081 15.4879V13.4305H18.1497V15.4879C18.1497 15.7974 18.4028 16.0508 18.7121 16.0508Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04697 24.2406C0.471268 24.2406 0 24.7123 0 25.2903C0 25.8662 0.471268 26.3379 1.04697 26.3379H27.9513C28.1814 26.3379 28.3962 26.2633 28.5683 26.1359C28.8296 25.9441 29 25.6361 29 25.2903C29 24.9425 28.8296 24.6347 28.5683 24.4426C28.3962 24.3167 28.1814 24.2406 27.9513 24.2406H1.04697Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04697 24.2406C0.471268 24.2406 0 24.7123 0 25.2903C0 25.8662 0.471268 26.3379 1.04697 26.3379H2.98868C2.4132 26.3379 1.94171 25.8662 1.94171 25.2903C1.94171 24.8201 2.25456 24.4196 2.68114 24.2871C2.68446 24.2871 2.68777 24.2853 2.69264 24.2838C2.7869 24.2557 2.88624 24.2406 2.9889 24.2406H1.04697Z",
    fill: "#525252"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2998_4576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentHoodSampleAgents);
export default __webpack_public_path__ + "static/media/AgentHoodSampleAgents.b6251d4de741fb8b263d51a649c9a794.svg";
export { ForwardRef as ReactComponent };